import React from "react";
import PropTypes from "prop-types";

import styles from "./HighlightBlock.module.css";

const HighlightBlock = (props) => {
  const {
    data: { text = "", body = { text } },
  } = props;

  function createTitleMarkup() {
    return { __html: text };
  }

  function createBodyMarkup() {
    return { __html: body.text };
  }

  return (
    <div className={styles.highlightContainer}>
      <div className={styles.highlightBar}>
        <span
          className={styles.titleBlock}
          dangerouslySetInnerHTML={createTitleMarkup()}
        />
        <div
          className={styles.textBlock}
          dangerouslySetInnerHTML={createBodyMarkup()}
        />
      </div>
    </div>
  );
};

export default HighlightBlock;

HighlightBlock.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string,
    body: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
};
